// src/pages/KVKK_Basvuru_Formu.jsx
import React, { useState } from "react";

const KVKK_Basvuru_Formu = () => {
  const [formData, setFormData] = useState({
    adSoyad: "",
    tcKimlik: "",
    email: "",
    telefon: "",
    sehir: "",
    ilce: "",
    acikAdres: "",
    talepKategorisi: "",
    talepDetay: "",
    ekDosya: null
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    
    if (name === "ekDosya") {
      setFormData(prev => ({ ...prev, [name]: files[0] }));
    } else if (name === "telefon") {
      // Sadece rakamları kabul et ve maksimum 10 karakter
      const numericValue = value.replace(/\D/g, '').slice(0, 10);
      setFormData(prev => ({ ...prev, [name]: numericValue }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Form gönderme işlemleri burada yapılacak
    console.log("Form verileri:", formData);
    alert("KVKK başvurunuz alınmıştır. En kısa sürede size dönüş yapılacaktır.");
  };

  const formatPhoneNumber = (value) => {
    if (!value) return "";
    return `+90 ${value}`;
  };

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>KVKK BAŞVURU FORMU</h1>

        <section style={styles.section}>
          <p style={styles.text}>
            <strong>KVKK Kapsamındaki Haklarınız</strong><br />
            6698 sayılı Kişisel Verilerin Korunması Kanunu'nun 11. maddesi uyarınca, 
            Şirketimize başvurarak aşağıdaki haklara sahipsiniz:
          </p>
          <ul style={styles.list}>
            <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme,</li>
            <li>İşlenmişse buna ilişkin bilgi talep etme,</li>
            <li>Amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
            <li>Eksik veya yanlış işlenmişse düzeltilmesini talep etme,</li>
            <li>Silinmesini veya yok edilmesini isteme,</li>
            <li>Bu işlemlerin aktarıldığı üçüncü kişilere bildirilmesini talep etme,</li>
            <li>İşleme sonucu aleyhinize bir sonucun ortaya çıkması hâlinde itiraz etme,</li>
            <li>Kanuna aykırı işlem nedeniyle zararınızın giderilmesini isteme.</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Başvuru Formu</h2>
          <form onSubmit={handleSubmit} style={styles.form}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Ad Soyad *</label>
              <input
                type="text"
                name="adSoyad"
                value={formData.adSoyad}
                onChange={handleChange}
                style={styles.input}
                required
                placeholder="Adınız ve soyadınız"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>TC Kimlik No *</label>
              <input
                type="text"
                name="tcKimlik"
                value={formData.tcKimlik}
                onChange={handleChange}
                style={styles.input}
                required
                maxLength="11"
                pattern="[0-9]{11}"
                placeholder="11 haneli TC kimlik numaranız"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>E-posta *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                style={styles.input}
                required
                placeholder="ornek@email.com"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Telefon *</label>
              <div style={styles.phoneInputContainer}>
                <span style={styles.phonePrefix}>+90</span>
                <input
                  type="text"
                  name="telefon"
                  value={formData.telefon}
                  onChange={handleChange}
                  style={styles.phoneInput}
                  required
                  maxLength="10"
                  pattern="[0-9]{10}"
                  placeholder="5xx xxx xx xx"
                />
              </div>
              {formData.telefon && (
                <small style={styles.phonePreview}>
                  Tam numara: {formatPhoneNumber(formData.telefon)}
                </small>
              )}
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Şehir *</label>
              <input
                type="text"
                name="sehir"
                value={formData.sehir}
                onChange={handleChange}
                style={styles.input}
                required
                placeholder="Yaşadığınız şehir"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>İlçe *</label>
              <input
                type="text"
                name="ilce"
                value={formData.ilce}
                onChange={handleChange}
                style={styles.input}
                required
                placeholder="Yaşadığınız ilçe"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Açık Adres *</label>
              <textarea
                name="acikAdres"
                value={formData.acikAdres}
                onChange={handleChange}
                style={styles.textarea}
                rows="3"
                required
                placeholder="Cadde, sokak, apartman, daire ve diğer adres bilgileriniz"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Talep Kategorisi *</label>
              <select
                name="talepKategorisi"
                value={formData.talepKategorisi}
                onChange={handleChange}
                style={styles.select}
                required
              >
                <option value="">Lütfen seçiniz</option>
                <option value="bilgi_ogrenme">Kişisel verilerin işlenip işlenmediğini öğrenme</option>
                <option value="bilgi_talep">İşlenmişse buna ilişkin bilgi talep etme</option>
                <option value="amac_kontrol">Amacına uygun kullanılıp kullanılmadığını öğrenme</option>
                <option value="düzeltme">Eksik/yanlış verilerin düzeltilmesini talep etme</option>
                <option value="silme">Silinmesini veya yok edilmesini isteme</option>
                <option value="bildirim">İşlemlerin üçüncü kişilere bildirilmesini talep etme</option>
                <option value="itiraz">İtiraz etme</option>
                <option value="zarar">Zararın giderilmesini isteme</option>
              </select>
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Talep Detayı *</label>
              <textarea
                name="talepDetay"
                value={formData.talepDetay}
                onChange={handleChange}
                style={styles.textarea}
                rows="5"
                placeholder="Lütfen talebinizi detaylı bir şekilde açıklayınız..."
                required
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Ek Dosya *</label>
              <input
                type="file"
                name="ekDosya"
                onChange={handleChange}
                style={styles.fileInput}
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                required
              />
              <small style={styles.smallText}>
                PDF, Word, JPG, PNG formatlarını kabul ediyoruz. Maksimum dosya boyutu: 5MB
              </small>
            </div>

            <div style={styles.formGroup}>
              <button type="submit" style={styles.submitButton}>
                Başvuruyu Gönder
              </button>
            </div>
          </form>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Önemli Bilgiler</h2>
          <ul style={styles.list}>
            <li>Başvurularınız en geç 30 gün içinde değerlendirilecektir.</li>
            <li>Başvurunuzun işleme alınabilmesi için tüm alanları doldurmanız gerekmektedir.</li>
            <li>Başvurunuzu yazılı olarak şirket adresimize de iletebilirsiniz.</li>
          </ul>
        </section>

        <section style={styles.section}>
          <p style={styles.text}>
            <strong>İletişim Bilgileri:</strong><br />
            Von Dijital Yazılım Hizmetleri LTD. ŞTİ.<br />
            Adres: Göztepe Mah. Mithatpaşa Cad. Gürsoy No: 856/1B Konak/İzmir <br />
            E-posta: <a href="mailto:info@vondigital.com.tr" style={styles.link}>info@vondigital.com.tr</a><br />
          </p>
        </section>
      </div>
    </div>
  );
};

const styles = {
  page: {
    backgroundColor: "#f7f7f7",
    minHeight: "100vh",
    padding: "60px 20px",
    display: "flex",
    justifyContent: "center",
  },
  container: {
    maxWidth: "900px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "40px 30px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    lineHeight: "1.7",
  },
  title: {
    fontSize: "24px",
    fontWeight: "700",
    textAlign: "center",
    marginBottom: "30px",
    color: "#222",
  },
  section: {
    marginBottom: "30px",
  },
  heading: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#333",
    marginBottom: "15px",
    borderBottom: "2px solid #f0f0f0",
    paddingBottom: "8px",
  },
  text: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "10px",
  },
  list: {
    paddingLeft: "20px",
    color: "#555",
    fontSize: "14px",
    marginBottom: "10px",
  },
  link: {
    color: "#0056b3",
    textDecoration: "none",
  },
  form: {
    width: "100%",
  },
  formGroup: {
    marginBottom: "20px",
  },
  label: {
    display: "block",
    marginBottom: "5px",
    fontWeight: "500",
    color: "#333",
    fontSize: "14px",
  },
  input: {
    width: "100%",
    padding: "10px 12px",
    border: "1px solid #ddd",
    borderRadius: "6px",
    fontSize: "14px",
    transition: "border-color 0.3s ease",
    boxSizing: "border-box",
  },
  phoneInputContainer: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #ddd",
    borderRadius: "6px",
    overflow: "hidden",
  },
  phonePrefix: {
    padding: "10px 12px",
    backgroundColor: "#f5f5f5",
    borderRight: "1px solid #ddd",
    fontSize: "14px",
    color: "#666",
    fontWeight: "500",
  },
  phoneInput: {
    flex: 1,
    padding: "10px 12px",
    border: "none",
    fontSize: "14px",
    outline: "none",
  },
  phonePreview: {
    fontSize: "12px",
    color: "#0056b3",
    marginTop: "5px",
    display: "block",
    fontStyle: "italic",
  },
  textarea: {
    width: "100%",
    padding: "10px 12px",
    border: "1px solid #ddd",
    borderRadius: "6px",
    fontSize: "14px",
    fontFamily: "inherit",
    resize: "vertical",
    transition: "border-color 0.3s ease",
    boxSizing: "border-box",
  },
  select: {
    width: "100%",
    padding: "10px 12px",
    border: "1px solid #ddd",
    borderRadius: "6px",
    fontSize: "14px",
    backgroundColor: "white",
    transition: "border-color 0.3s ease",
    boxSizing: "border-box",
  },
  fileInput: {
    width: "100%",
    padding: "8px 0",
    fontSize: "14px",
  },
  smallText: {
    fontSize: "12px",
    color: "#666",
    marginTop: "5px",
    display: "block",
  },
  submitButton: {
    backgroundColor: "#0056b3",
    color: "white",
    padding: "12px 30px",
    border: "none",
    borderRadius: "6px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    width: "100%",
  },
};

// Input focus stilleri
const inputFocusStyle = {
  borderColor: "#ddd",
  outline: "none",
  boxShadow: "0 0 0 2px rgba(0, 86, 179, 0.1)",
};

// Stilleri dinamik olarak uygulamak için
styles.input = {
  ...styles.input,
  ...inputFocusStyle,
};

styles.textarea = {
  ...styles.textarea,
  ...inputFocusStyle,
};

styles.select = {
  ...styles.select,
  ...inputFocusStyle,
};

styles.phoneInputContainer = {
  ...styles.phoneInputContainer,
  ":focus-within": inputFocusStyle,
};

styles.submitButton = {
  ...styles.submitButton,
  ":hover": {
    backgroundColor: "#004494",
  },
};

export default KVKK_Basvuru_Formu;